/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Registration_No_PendingInputs */

const en_admin_registration_no_pending = /** @type {(inputs: Admin_Registration_No_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pending registrations.`)
};

const de_admin_registration_no_pending = /** @type {(inputs: Admin_Registration_No_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine ausstehenden Registrierungen.`)
};

/**
* | output |
* | --- |
* | "No pending registrations." |
*
* @param {Admin_Registration_No_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_registration_no_pending = /** @type {((inputs?: Admin_Registration_No_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Registration_No_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_registration_no_pending(inputs)
	return en_admin_registration_no_pending(inputs)
});